import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "dashboard-container" }
const _hoisted_2 = { class: "dashboard-header m-surface" }
const _hoisted_3 = { class: "header-right" }
const _hoisted_4 = { class: "header-date" }
const _hoisted_5 = { class: "metric-grid" }
const _hoisted_6 = { class: "dashboard-body" }
const _hoisted_7 = { class: "body-panel m-surface" }
const _hoisted_8 = { class: "action-grid" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "action-info" }
const _hoisted_11 = { class: "action-title" }
const _hoisted_12 = { class: "action-desc" }
const _hoisted_13 = { class: "body-panel m-surface" }
const _hoisted_14 = { class: "notice-list" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "notice-content" }
const _hoisted_17 = ["title"]
const _hoisted_18 = { class: "notice-time" }
const _hoisted_19 = { class: "notice-tag" }
const _hoisted_20 = {
  key: 0,
  class: "notice-empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_MetricCard = _resolveComponent("MetricCard")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "header-left" }, [
        _createElementVNode("div", { class: "header-eyebrow" }, [
          _createElementVNode("span", { class: "live-pulse" }),
          _createElementVNode("span", null, "系统在线 · 实时运营雷达")
        ]),
        _createElementVNode("h1", { class: "header-title" }, "企业业务全景工作台")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          class: "refresh-btn",
          size: "small",
          loading: _ctx.loading,
          onClick: _ctx.loadAllData
        }, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createElementVNode("i", { class: "iconfont icon-tubiao-27 mr-5" }, null, -1),
            _createTextVNode(" 刷新指标 ", -1)
          ]))]),
          _: 1
        }, 8, ["loading", "onClick"]),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.currentDate), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_MetricCard, {
        label: "本年度订单总额",
        value: _ctx.radarData.orderTotalAmount,
        prefix: "¥",
        decimals: 2,
        clickable: true,
        hint: _ctx.radarData.orderHint,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToRoute('/order/Index')))
      }, null, 8, ["value", "hint"]),
      _createVNode(_component_MetricCard, {
        label: "待审订单单据",
        value: _ctx.radarData.pendingApprovals,
        unit: "件",
        clickable: true,
        hint: "点击直达订单审批中心处理待办",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToRoute('/approval/approvalOrder/Index')))
      }, null, 8, ["value"]),
      _createVNode(_component_MetricCard, {
        label: "流转中业务工单",
        value: _ctx.radarData.inProgressBusiness,
        unit: "单",
        clickable: true,
        hint: _ctx.radarData.businessHint,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToRoute('/business/businessList/Index')))
      }, null, 8, ["value", "hint"]),
      _createVNode(_component_MetricCard, {
        label: "流转中待收款项",
        value: _ctx.radarData.pendingReceived,
        unit: "笔",
        clickable: true,
        hint: "点击直达待收款列表处理财务",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToRoute('/financial/Index')))
      }, null, 8, ["value"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "panel-head" }, [
          _createElementVNode("span", { class: "panel-title" }, "高频业务快捷通道"),
          _createElementVNode("span", { class: "panel-sub" }, "常用作业一键直达")
        ], -1)),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.quickActions, (act) => {
            return (_openBlock(), _createElementBlock("div", {
              key: act.title,
              class: "action-card m-groove",
              onClick: ($event: any) => (_ctx.goToRoute(act.path))
            }, [
              _createElementVNode("div", {
                class: "action-icon",
                style: _normalizeStyle({ color: act.color })
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["iconfont", act.icon])
                }, null, 2)
              ], 4),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(act.title), 1),
                _createElementVNode("span", _hoisted_12, _toDisplayString(act.desc), 1)
              ])
            ], 8, _hoisted_9))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "panel-head" }, [
          _createElementVNode("span", { class: "panel-title" }, "流转预警与操作审计"),
          _createElementVNode("span", { class: "panel-sub" }, "近 24 小时动态")
        ], -1)),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.noticeList, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id,
              class: _normalizeClass(["notice-item", { 'is-clickable': !!item.targetUrl }]),
              onClick: ($event: any) => (_ctx.handleNoticeClick(item))
            }, [
              _createElementVNode("span", {
                class: _normalizeClass(["notice-dot", item.type])
              }, null, 2),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("span", {
                  class: "notice-title",
                  title: item.title
                }, _toDisplayString(item.title), 9, _hoisted_17),
                _createElementVNode("span", _hoisted_18, _toDisplayString(item.time), 1)
              ]),
              _createElementVNode("span", _hoisted_19, _toDisplayString(item.tag), 1)
            ], 10, _hoisted_15))
          }), 128)),
          (!_ctx.noticeLoading && _ctx.noticeList.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, " 暂无最新流转预警与操作动态 "))
            : _createCommentVNode("", true)
        ])), [
          [_directive_loading, _ctx.noticeLoading]
        ])
      ])
    ])
  ]))
}